import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 引入权限
import "./permission.js";

// 引入elementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 引入字体
import "@/styles/iconfont/iconfont.css";

// 无限滚动
import scroll from "vue-seamless-scroll";
Vue.use(scroll);

Vue.use(ElementUI);

// 引入公共样式
import "@/styles/common.scss";
import "@/styles/index-dialog.scss";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
